module.exports = __webpack_public_path__ + "img/ic_down.4d5fa57c.svg";